import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { Box, TextLink } from '../../../ui-kit';
import Text from '../../../ui-kit/Text';
import AlertSuccessIcon from '../../../ui-kit/icons/AlertSuccessIcon';
import colors from '../../../ui-kit/themes/colors';
import { editCopyByReplaceString } from '../../../utilities/copyFunctions';
import { SummaryContent } from '../Content/SummaryContent';
import SummaryItem from '../SummaryItem';
import * as COPY from './utilities/copy';

const SimpleSummaryDescription = ({ fullWidthDescription, description }) => {
  if (!fullWidthDescription)
    return (
      <SummaryItem
        labelTitle={COPY.PACKAGE_DESCRIPTION_SECTION}
        leftColumn={
          <Text lineHeight={18} fontSize={0} fontWeight="medium">
            {description}
          </Text>
        }
      />
    );
  return (
    <Text lineHeight={18} fontSize={0} fontWeight="medium" mb={3}>
      {description}
    </Text>
  );
};
const SimpleSummaryInfo = ({
  promoCode,
  description,
  fullWidthDescription,
  productTitle,
  productDescription,
  price,
  navigationText,
  onNavigateLinkClick,
  includedList
}) => {
  const onSeasonPassPaymentPage = window.location.pathname.includes('/seasonpass/payment');
  const shouldRenderDescription = description && !onSeasonPassPaymentPage;
  return (
    <Box pt={3} color="deepLakeBlue.100">
      <SummaryItem
        mb={0}
        labelTitle={COPY.PRICE_SECTION}
        leftColumn={
          <>
            <Text lineHeight={16} fontSize={0} fontWeight="bold">
              {productTitle}
            </Text>
            <Text lineHeight={16} fontSize={0} mt={3} fontWeight="medium">
              {productDescription}
            </Text>
          </>
        }
        rightColumn={
          <Text fontSize={0} fontWeight="bold">
            ${price}
          </Text>
        }
      />

      {shouldRenderDescription && (
        <SimpleSummaryDescription fullWidthDescription={fullWidthDescription} description={description} />
      )}

      {includedList?.map((item, key) => (
        <SummaryContent.Item mb={1} mt={'0px'} key={key}>
          <SummaryContent.Description>
            <Text fontSize={0} lineHeight={18}>
              {ReactHtmlParser(item)}
            </Text>
          </SummaryContent.Description>
          <SummaryContent.SubtotalAmount>
            <Text fontSize={0} lineHeight={18}>
              {COPY.SUMMARY_INCLUDED}
            </Text>
          </SummaryContent.SubtotalAmount>
        </SummaryContent.Item>
      ))}

      {navigationText ? (
        <TextLink lineHeight={16} fontSize={9} fontWeight="bold" onClick={onNavigateLinkClick} mt={2}>
          {navigationText}
        </TextLink>
      ) : null}

      {promoCode ? (
        <SummaryContent.Item fontWeight="bold" color="deepForestGreen.100">
          <SummaryContent.Description>
            <Text lineHeight={16} fontSize={0}>
              {editCopyByReplaceString(COPY.PROMOCODE_APPLIED, promoCode, '<PROMOCODE>')}
            </Text>
          </SummaryContent.Description>
          <AlertSuccessIcon color={colors.successGreen} size={20.5} />
        </SummaryContent.Item>
      ) : null}
    </Box>
  );
};

SimpleSummaryInfo.propTypes = {
  passTitle: PropTypes.string,
  rate: PropTypes.number,
  promoCode: PropTypes.string,
  dayPassPromoDescription: PropTypes.string,
  amountOfDayPasses: PropTypes.number
};

SimpleSummaryInfo.defaultProps = {
  rate: 0.0
};

export default SimpleSummaryInfo;
